import React, {Component} from 'react';
import FavoriteCard from '../components/fav_card_component';
import {CardContainer, TitleContainer, JourneyContainer, NoSelection} from '../styles/journey_styles';
import JourneySection from '../components/journey_section';

export default class Journey extends Component {
  constructor(props){
    super(props);
    this.state = {
      hotel_favs: props.hotel_favs,
      attraction_favs: props.attraction_favs,
      restaurant_favs: props.restaurant_favs
    }
  }

  UNSAFE_componentWillReceiveProps(props){
    var hotel_favs = props.hotel_favs
    var attraction_favs= props.attraction_favs
    var restaurant_favs= props.restaurant_favs

    this.setState(
      {
        hotel_favs: hotel_favs,
        attraction_favs: attraction_favs,
        restaurant_favs: restaurant_favs
      },
      ()=> {console.log(this.state.hotel_favs, this.state.restaurant_favs, this.state.attraction_favs)}
    )
  }

  renderingFavs(favs_arr, domain){
    var cards = []
    if(favs_arr){
    cards = this.displayFavorites(favs_arr)
    }
    return(
      <JourneyContainer>
        <TitleContainer>
          <JourneySection business_type={domain}/>
        </TitleContainer>
        <CardContainer>
          {cards}
        </CardContainer>
      </JourneyContainer>
    )
  }

  displayFavorites(favs){
    var elements=[]
    if(favs.length === 0){
      var message = (<NoSelection></NoSelection>)
      return message
    } else {
      Object.keys(favs).forEach(function(k){
        var obj = favs[k];
        elements.push(<FavoriteCard key={obj.name} data={obj}  eventLogToServer={this.props.eventLogToServer} renderRevSummary={this.props.renderRevSummary} updateFavorites={this.props.updateFavorites}/>);
        }, this);
    }
    return elements
  }

  render() {
    return(
      <div>
        {this.renderingFavs(this.state.hotel_favs, "hotel")}
        {this.renderingFavs(this.state.attraction_favs, "attraction")}
        {this.renderingFavs(this.state.restaurant_favs, "restaurant")}
      </div>
    )
  }

}
